import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import ServiceLogo from 'assets/images/Dashboard/Logo.png';
import ReusableButton from 'components/common/Button';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import { superAdminCampaigns } from 'routes/AppUrls';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import leftArrow from 'assets/images/Dashboard/arrow-left.png';
import SelectInput from 'components/common/Input/SelectInput';
import { useDropzone } from 'react-dropzone';
import ReusableDateRangePicker from 'components/common/DateRangePicker';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryCallAPI } from 'store/SuperAdmin/getCategory/action';
import { getAllProviderListCallAPI } from 'store/SuperAdmin/getAllProviderList/action';
import ToastNotification from 'components/common/Toast';
import { addCampaignCallAPI } from 'store/SuperAdmin/createCampaign/action';
import CheckValidation from 'utils/Validation';
import moment from 'moment';
import { imageUploadCallAPI } from 'store/ImageUpload/action';
import { getAssociationCallAPI } from 'store/SuperAdmin/getAssociationsList/action';
import MultiSelectChip from 'components/common/Input/MultiSelectChip';
import dayjs from 'dayjs';
import { updateCampaignCallAPI } from 'store/SuperAdmin/updateCampaign/action';
import { getDiscountTypeCallAPI } from 'store/SuperAdmin/getDiscountType/action';
import { getProvidreSalonListCallAPI } from 'store/SuperAdmin/getProviderSalonList/action';
import CircularProgress from '@mui/material/CircularProgress';
import Lottie from 'lottie-react';

const AssociationBasedCampaign = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [isError, setIsError] = useState(null);
  const [conf, setConf] = ToastNotification();
  const [latLng, setLatLng] = useState({ lat: 28.525377, lng: 77.280106 });
  const [animationData, setAnimationData] = useState(null);

  const [categoryData, setCategoryData] = useState([]);
  const [associationData, setAssociationData] = useState([]);
  const [providerData, setProviderData] = useState([]);

  const [discountTypeData, setDiscountTypeData] = useState([]);

  const { state } = useLocation();

  const campaignLoader = useSelector(
    (state) =>
      state?.addCampaignReducer?.loading ||
      state?.updateCampaignReducer?.loading
  );

  const [bannerImage, setBannerImage] = useState(
    state?.campaignData ? state?.campaignData?.english_banner_image : null
  );
  const [dateRange, setDateRange] = useState([
    state?.campaignData ? dayjs(state?.campaignData?.start_date) : null,
    state?.campaignData ? dayjs(state?.campaignData?.end_date) : null,
  ]);

  const countryCityData = useSelector(
    (state) => state?.countryCityDropdownReducer?.data?.data
  );
  const dayListData = useSelector(
    (state) => state?.getAppointmentDaysReducer?.data?.data
  );
  const [selectedDay, setSelectedDay] = useState(
    state?.campaignData
      ? state?.campaignData?.weekday?.length > 0
        ? state.campaignData.weekday.map((k) => k?.id)
        : []
      : dayListData?.length > 0
        ? dayListData.map((k) => k?.id)
        : []
  );

  const [formValue, setFormValue] = useState({
    campaignName: state?.campaignData ? state?.campaignData?.name : '',
    country: state?.campaignData ? state?.campaignData?.country?.name : '',
    city: state?.campaignData ? state?.campaignData?.cities?.name : '',
    link: state?.campaignData ? state?.campaignData?.english_link : '',
    startDate: state?.campaignData
      ? dayjs(state?.campaignData?.start_date)
      : '',
    endDate: state?.campaignData ? dayjs(state?.campaignData?.end_date) : '',
    description: state?.campaignData
      ? state?.campaignData?.english_description
      : '',
    bannerImage: state?.campaignData
      ? state?.campaignData?.english_banner_image?.id
      : null,
    provider: state?.campaignData ? state?.campaignData?.providers : '',
    promotion_discounts: state?.campaignData
      ? state?.campaignData?.discounts[0]?.id
      : '',
    //associations: state?.campaignData ? state?.campaignData?.association : '',
  });

  const [formId, setFormId] = useState({
    country: state?.campaignData ? state?.campaignData?.country?.id : '',
    city: state?.campaignData ? state?.campaignData?.cities?.id : '',
    promotion_discounts: state?.campaignData
      ? state?.campaignData?.discounts[0]?.id
      : '',
  });

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title: <FormattedMessage id="Campaigns" />,
      Link: superAdminCampaigns(locale),
      isDisbale: false,
    },
    {
      title: <FormattedMessage id="Association Based" />,
      Link: '',
      isDisbale: true,
    },
  ]);

  useEffect(() => {
    getCategoryList();
    getAllProvider();
    getAssociationsList();
    getDiscountTypeList();
  }, []);

  const getCategoryList = () => {
    dispatch(
      getCategoryCallAPI(
        {},
        {
          run: true,
          navigate: navigate,
          handleFunction: (res) => handleCategorySuccess(res),
        }
      )
    );
  };

  const getAssociationsList = () => {
    dispatch(
      getAssociationCallAPI(
        {},
        {
          run: true,
          navigate: navigate,
          handleFunction: (res) => handleAssociationSuccess(res),
        }
      )
    );
  };

  const getAllProvider = (page = 1, slug = '') => {
    let data = { pageSize: 100, pageNumber: page, slug: slug };
    dispatch(
      getProvidreSalonListCallAPI(
        { data },
        {
          run: true,
          handleFunction: (res) => handleProviderSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const getDiscountTypeList = () => {
    dispatch(
      getDiscountTypeCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleDiscountTypeSuccess(res),
          naviagte: navigate,
        }
      )
    );
  };

  const handleCategorySuccess = (res) => {
    setCategoryData(res?.data?.data);
  };

  const handleAssociationSuccess = (res) => {
    setAssociationData(res?.data?.data);
  };

  const handleProviderSuccess = (res) => {
    setProviderData(res?.data?.data);
  };

  const handleDiscountTypeSuccess = (res) => {
    setDiscountTypeData(res?.data?.data);
  };

  const handleDiscountSelect = (value) => {
    setFormValue({ ...formValue, ['promotion_discounts']: value?.id });
    setFormId({ ...formId, ['promotion_discounts']: value?.id });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleMultiSelectChip = (name, data) => {
    setFormValue({ ...formValue, [name]: data });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'provider') {
      setFormValue({ ...formValue, [name]: value?.name?.name_en });
    } else {
      setFormValue({ ...formValue, [name]: value?.name });
    }
    setFormId({ ...formId, [name]: value?.id });
    if (name === 'city') {
      setLatLng({ lat: value?.latitude, lng: value?.longitude });
    }
  };

  const handleWeekdaySelect = (value) => {
    setSelectedDay((prev) => {
      if (prev.includes(value.id)) {
        return prev.filter((id) => id !== value.id);
      } else {
        return [...prev, value.id];
      }
    });
  };

  const handleDateRange = (value) => {
    setDateRange(value);
    setFormValue({
      ...formValue,
      ['startDate']: value?.[0],
      ['endDate']: value?.[1],
    });
  };

  /////////////////Drag & Drop //////////////////

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      let fileType = 'I';
      if (acceptedFiles[0].type.startsWith('image/')) {
        fileType = 'I';
      } else if (acceptedFiles[0].type === 'application/json') {
        fileType = 'J';
      } else if (acceptedFiles[0].type.startsWith('video/')) {
        fileType = 'V';
      } else {
        console.log('Unsupported file type');
      }

      let formData = new FormData();
      formData.append('filePath', acceptedFiles[0]);
      formData.append('fileType', fileType);
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleImageSuccess(res),
          toast: true,
          handleToastError: (res) => handleUploadError(res),
        })
      );
    }
  };

  const handleImageSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setBannerImage(res?.data?.data?.[0]);
    setFormValue({ ...formValue, ['bannerImage']: res?.data?.data?.[0]?.id });
  };

  const handleUploadError = (res) => {
    setConf({
      msg: res?.data?.message || 'file size should be less than 2mb',
      variant: 'error',
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.png', '.jpg', '.jpeg'],
      'video/*': ['.mp4', '.mov', '.webm'],
      'application/json': ['.json'],
    },
    multiple: false, // Only allow single file upload
  });

  const handleCreateCampaign = () => {
    const {
      campaignName,
      country,
      city,
      description,
      startDate,
      endDate,
      provider,
      promotion_discounts,
      //category,
      //associations,
    } = formValue;
    const error = CheckValidation({
      campaignName,
      country,
      city,
      description,
      startDate,
      endDate,
      provider,
      promotion_discounts,
      //category,
      //associations,
    });
    setIsError(error);

    if (error.submit) {
      if (!formValue?.bannerImage) {
        return setConf({
          msg: 'banner image is required. Please upload a banner image.',
          variant: 'error',
        });
      }

      if (selectedDay.length === 0) {
        return setConf({
          msg: 'active days is required. Please select aactive days.',
          variant: 'error',
        });
      }

      let body = {
        name: formValue?.campaignName,
        arbic_name: formValue?.campaignName,
        english_banner_image: formValue?.bannerImage,
        arbic_banner_image: formValue?.bannerImage,
        cities: formId?.city,
        country: formId?.country,
        start_date:
          moment(formValue?.startDate?.['$d']).format('YYYY-MM-DD') ?? '',
        end_date: moment(formValue?.endDate?.['$d']).format('YYYY-MM-DD') ?? '',
        campaign_type: state?.campaignTypeId,
        english_description: formValue?.description,
        arbic_description: formValue?.description,
        weekday: selectedDay ?? [],
        /*promotion_categories:
          (formValue?.category?.length > 0 &&
            formValue.category.map((k) => k?.id)) ||
          [],*/
        promotion_providers:
          (formValue?.provider?.length > 0 &&
            formValue.provider.map((k) => k?.id)) ||
          [],
        promotion_discounts: formValue?.promotion_discounts
          ? [formValue?.promotion_discounts]
          : [],
        /*promotion_association:
          (formValue?.associations?.length > 0 &&
            formValue.associations.map((k) => k?.id)) ||
          [],*/
      };
      state?.campaignData
        ? dispatch(
            updateCampaignCallAPI(body, {
              id: state?.campaignData?.id,
              run: true,
              latlng: latLng,
              handleFunction: (res) => handleRedirect(res),
              toast: true,
              handleToastError: (res) => handleRedirectError(res),
              navigate: navigate,
            })
          )
        : dispatch(
            addCampaignCallAPI(body, {
              run: true,
              latlng: latLng,
              handleFunction: (res) => handleRedirect(res),
              toast: true,
              handleToastError: (res) => handleRedirectError(res),
              navigate: navigate,
            })
          );
    } else {
      return setConf({
        msg: 'Please fill required field.',
        variant: 'error',
      });
    }
  };

  const handleRedirect = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    navigate(superAdminCampaigns(locale));
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  useEffect(() => {
    const fetchLottieJSON = async () => {
      if (
        bannerImage?.fileType === 'J' &&
        (bannerImage?.filePath || bannerImage?.file_url)
      ) {
        try {
          const response = await fetch(
            bannerImage.filePath || bannerImage.file_url
          );
          const data = await response.json();
          setAnimationData(data);
        } catch (error) {
          console.error('Error loading Lottie JSON:', error);
        }
      }
    };

    fetchLottieJSON();
  }, [bannerImage]);

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <div className="flex justify-between items-center">
            <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
              <Stack direction="horizontal" gap={2} className="items-center">
                <img
                  src={leftArrow}
                  alt="icon"
                  style={{ height: '32px', width: '32px' }}
                  className="cursor-pointer"
                  onClick={() => navigate(superAdminCampaigns(locale))}
                />
                <p className="p-0 m-0">
                  <FormattedMessage id="Association Based" />
                </p>
              </Stack>
            </h2>
            <img
              src={ServiceLogo}
              alt={'logo'}
              style={{ height: '64px', width: '96px' }}
            />
          </div>

          <Col sm={12} md={6} className="">
            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Campaign Name" />}
                required={true}
                placeholder={intl.formatMessage({
                  id: 'Campaign Name',
                })}
                name="campaignName"
                type="text"
                value={formValue?.campaignName}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.campaignName?.error &&
                  isError?.campaignName?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Validity" />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: '14px',
                  }}
                >
                  *
                </span>
              </p>
              <div className="mt-2">
                <ReusableDateRangePicker
                  value={dateRange}
                  onChange={handleDateRange}
                  errorText={
                    isError &&
                    (isError?.startDate?.error || isError?.endDate?.error) &&
                    (isError?.startDate?.errorMessage ||
                      isError?.endDate?.errorMessage)
                  }
                />
              </div>
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Description" />}
                required={true}
                placeholder={intl.formatMessage({ id: 'Description' })}
                height="160"
                multiline
                name="description"
                value={formValue?.description}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.description?.error &&
                  isError?.description?.errorMessage
                }
              />
            </Col>

            {/*<Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Select Category" />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: '14px',
                  }}
                >
                  *
                </span>
              </p>
              <div className="mt-2">
                <MultiSelectChip
                  options={categoryData}
                  value={formValue?.category}
                  onSelect={(selected) =>
                    handleMultiSelectChip('category', selected)
                  }
                  onRemove={(removed) =>
                    handleMultiSelectChip('category', removed)
                  }
                  onSearch={(searchTerm) => console.log(searchTerm)}
                  height="50px"
                  // width="400px"
                  dropdownBg="#fff7ed"
                  chipBg="#22c55e" // Tailwind green-500
                  errorText={
                    isError &&
                    isError.category.error &&
                    isError.category.errorMessage
                  }
                />
              </div>
            </Col>*/}

            <Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Select Provider" />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: '14px',
                  }}
                >
                  *
                </span>
              </p>

              <div className="mt-2">
                <MultiSelectChip
                  options={providerData}
                  value={formValue?.provider}
                  onSelect={(selected) =>
                    handleMultiSelectChip('provider', selected)
                  }
                  onRemove={(removed) =>
                    handleMultiSelectChip('provider', removed)
                  }
                  onSearch={(searchTerm) => console.log(searchTerm)}
                  height="50px"
                  // width="400px"
                  dropdownBg="#fff7ed"
                  chipBg="#22c55e" // Tailwind green-500
                  errorText={
                    isError &&
                    isError.provider.error &&
                    isError.provider.errorMessage
                  }
                />
              </div>
            </Col>

            {/*<Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Select Associations" />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: '14px',
                  }}
                >
                  *
                </span>
              </p>
              <div className="mt-2">
                <MultiSelectChip
                  options={associationData}
                  value={formValue?.associations}
                  onSelect={(selected) =>
                    handleMultiSelectChip('associations', selected)
                  }
                  onRemove={(removed) =>
                    handleMultiSelectChip('associations', removed)
                  }
                  onSearch={(searchTerm) => console.log(searchTerm)}
                  height="50px"
                  // width="400px"
                  dropdownBg="#fff7ed"
                  chipBg="#22c55e" // Tailwind green-500
                  errorText={
                    isError &&
                    isError.associations.error &&
                    isError.associations.errorMessage
                  }
                />
              </div>
            </Col>*/}

            <Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Select Discount" />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: '14px',
                  }}
                >
                  *
                </span>
              </p>

              <div className="mt-2 gap-3 flex text-center flex-wrap">
                {discountTypeData?.length > 0 &&
                  discountTypeData.map((item, index) => (
                    <div
                      className={`discountCampaign ${formId?.promotion_discounts === item?.id ? 'bc-292D32' : 'bc-FFFFFF'} cursor-pointer`}
                      onClick={() => handleDiscountSelect(item)}
                    >
                      <p
                        className={`p-0 m-0 fs-14 ${formId?.promotion_discounts === item?.id ? 'fc-FFFFFF' : 'fc-9A9A9A'}  fw-500 ff-Akkurat`}
                      >
                        {item?.name}
                      </p>
                    </div>
                  ))}
              </div>
            </Col>
          </Col>

          <Col sm={12} md={6} className="">
            <Col xs={12} md={12} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="Country" />}
                required={true}
                placeholder={intl.formatMessage({ id: 'Country' })}
                name={'country'}
                value={formValue?.country}
                data={countryCityData}
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError &&
                  isError.country.error &&
                  isError.country.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="City" />}
                required={true}
                placeholder={intl.formatMessage({ id: 'City' })}
                name={'city'}
                value={formValue?.city}
                data={
                  countryCityData?.find(
                    (value) => value?.name === formValue?.country
                  )?.city || []
                }
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError && isError.city.error && isError.city.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Active Days" />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: '14px',
                  }}
                >
                  *
                </span>
              </p>
              <div className="mt-2  gap-3 flex text-center flex-wrap">
                {dayListData?.length > 0 &&
                  dayListData.map((item, index) => (
                    <div
                      className={`weekdaysCampaign ${selectedDay.includes(item?.id) ? 'bc-292D32' : 'bc-FFFFFF'} cursor-pointer`}
                      onClick={() => handleWeekdaySelect(item)}
                    >
                      <p
                        className={`p-0 m-0 fs-14 ${selectedDay.includes(item?.id) ? 'fc-FFFFFF' : 'fc-9A9A9A'}  fw-500 ff-Akkurat`}
                      >
                        {item?.name?.substring(0, 2)}
                      </p>
                    </div>
                  ))}
              </div>
            </Col>

            <Col xs={12} md={12} className="pt-4 mt-4">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Banner Image" />{' '}
                <span
                  style={{
                    color: 'red',
                    fontSize: '14px',
                  }}
                >
                  *
                </span>
              </p>
              <div
                {...getRootProps()}
                className={`mt-2 bannerImage flex justify-center items-center cursor-pointer ${
                  isDragActive ? 'border-2 bColor-292D32' : ''
                }`}
              >
                <input {...getInputProps()} />
                {bannerImage ? (
                  <div>
                    <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                      {bannerImage.name}
                    </p>
                    <p className="p-0 m-0 fs-12 mt-2 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="Drag & Drop or Browse to change" />
                    </p>
                  </div>
                ) : (
                  <div>
                    <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="Drag & Drop or Browse" />
                    </p>
                    <p className="p-0 m-0 fs-12 mt-2 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="Only png & jpg formats are supported" />
                    </p>
                    <p className="p-0 m-0 fs-12 mt-2 fc-292D32 fw-400 ff-Akkurat">
                      <FormattedMessage id="Minimum image resolution should be 360x300" />
                    </p>
                  </div>
                )}
              </div>
              {bannerImage ? (
                <div className="mt-4">
                  {bannerImage?.fileType === 'I' && (
                    <img
                      src={bannerImage?.filePath || bannerImage?.file_url}
                      alt="Preview"
                      style={{
                        width: '100%',
                        height: '235px',
                        objectFit: 'cover',
                      }}
                    />
                  )}
                  {bannerImage?.fileType === 'V' && (
                    <video
                      src={bannerImage?.filePath || bannerImage?.file_url}
                      controls
                      alt="Preview"
                      style={{
                        width: '100%',
                        height: '235px',
                        objectFit: 'cover',
                      }}
                    />
                  )}
                  {bannerImage?.fileType === 'J' && (
                    <Lottie
                      animationData={animationData}
                      loop={true}
                      style={{
                        width: '100%',
                        height: '235px',
                        objectFit: 'cover',
                      }}
                    />
                  )}
                </div>
              ) : (
                <div className="mt-4 border-2 border-dashed  bannerImage flex justify-center items-center h-[235px]">
                  <p className="p-0 m-0 fs-12 mt-2 fc-292D32 fw-400 ff-Akkurat_Bold">
                    <FormattedMessage id="No image uploaded yet! (resolution 360 * 300)" />
                  </p>
                </div>
              )}
            </Col>
          </Col>

          <Row className="mt-4 items-end m-0 p-0">
            <div className="flex justify-end">
              <Stack direction="horizontal" gap={3} className="items-center">
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#292D32"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="transparent"
                  fontFamily="Akkurat"
                  onClick={() => navigate(superAdminCampaigns(locale))}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  endIcon={
                    campaignLoader && (
                      <CircularProgress
                        style={{
                          color: 'white',
                          width: '20px',
                          height: '20px',
                        }}
                      />
                    )
                  }
                  onClick={() => handleCreateCampaign()}
                >
                  <FormattedMessage id="Save & Add" />
                </ReusableButton>
              </Stack>
            </div>
          </Row>
        </Row>
      </Col>
    </Row>
  );
};

export default AssociationBasedCampaign;
